export default function SearchHighlight({ text, query }) {
  if (!query.trim()) return text;

  const regex = new RegExp(`(${query})`, "ig");
  const parts = text.split(regex);

  return (
    <>
      {parts.map((part, index) =>
        part.toLowerCase() === query.toLowerCase() ? (
          <mark key={`${part}-${index}`} className="rounded bg-foreground px-1 text-background">
            {part}
          </mark>
        ) : (
          <span key={`${part}-${index}`}>{part}</span>
        )
      )}
    </>
  );
}